import { css } from '@emotion/react';

import { ReactNode } from 'react';

import { Spacing } from 'chatie-design-system';

import { CSSProps, OnClickProps } from '../../utils/misc';

export type PadProps = {
  size?: number;
  sizes?: {
    left?: number;
    right?: number;
    top?: number;
    bottom?: number;
  };
  fillHorizontal?: boolean;
  fillVertical?: boolean;
};

type Props = {
  color?: string;
  borderColor?: string;
  backgroundColor?: string;
  children?: ReactNode;
};

const padCSS = (
  { left, right, top, bottom }: PadProps['sizes'] = {},
  color?: string,
  borderColor?: string,
  backgroundColor?: string
) => css`
  ${left !== undefined &&
  css`
    padding-left: ${left}px;
  `}

  ${right !== undefined &&
  css`
    padding-right: ${right}px;
  `}
  
  ${top !== undefined &&
  css`
    padding-top: ${top}px;
  `}
  
  ${bottom !== undefined &&
  css`
    padding-bottom: ${bottom}px;
  `}

  ${color &&
  css`
    color: ${color};
  `}
  ${borderColor &&
  css`
    border: 1px solid ${borderColor};
  `}
  ${backgroundColor &&
  css`
    background-color: ${backgroundColor};
  `}
`;

const Pad = ({
  className,
  size = Spacing.medium,
  sizes: { left, right, top, bottom } = {},
  fillHorizontal,
  fillVertical,
  color,
  borderColor,
  backgroundColor,
  children,
  onClick,
}: Props & PadProps & CSSProps & OnClickProps) => {
  const directions = {
    left: (fillHorizontal ? 0 : left) ?? size,
    right: (fillHorizontal ? 0 : right) ?? size,
    top: (fillVertical ? 0 : top) ?? size,
    bottom: (fillVertical ? 0 : bottom) ?? size,
  };

  return (
    <div
      css={padCSS(directions, color, borderColor, backgroundColor)}
      className={className}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Pad;
